import './bootstrap';

import {createApp, h,} from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import * as Sentry from '@sentry/vue';

import appPlugin from "@js/Plugins/appPlugin";
import broadcastPlugin from "@js/Plugins/broadcastPlugin";
import categoryPlugin from '@js/Plugins/categoryPlugin';
import companiesParametersPlugin from '@js/Plugins/companiesParametersPlugin';
import companyInvoicePlugin from '@js/Plugins/companyInvoicePlugin';
import companyPlanPlugin from '@js/Plugins/companyPlanPlugin';
import companyPlugin from '@js/Plugins/companyPlugin';
import companyRegionPlugin from '@js/Plugins/companyRegionPlugin';
import countryPlugin from '@js/Plugins/countryPlugin';
import fileRequestParametersPlugin from '@js/Plugins/fileRequestParametersPlugin';
import fileRequestStatusesPlugin from '@js/Plugins/fileRequestStatusesPlugin';
import importCompanyDistributorsPlugin from '@js/Plugins/importCompanyDistributorsPlugin';
import importPlugin from "@js/Plugins/importPlugin";
import invoicesParametersPlugin from '@js/Plugins/invoicesParametersPlugin';
import materialPlugin from '@js/Plugins/materialPlugin';
import brandsPlugin from '@js/Plugins/brandsPlugin';
import notificationPlugin from '@js/Plugins/notificationPlugin';
import regionPlugin from '@js/Plugins/regionPlugin';
import reportsParametersPlugin from "@js/Plugins/reportsParametersPlugin";
import rolePlugin from "@js/Plugins/rolePlugin";
import subscriptionsParametersPlugin from '@js/Plugins/subscriptionsParametersPlugin';
import userProfilePlugin from '@js/Plugins/userProfilePlugin';
import usersParametersPlugin from '@js/Plugins/usersParametersPlugin';
import userStatusPlugin from '@js/Plugins/userStatusPlugin';

const inertiaApp = createInertiaApp({
    // resolve: (name) => import(`./Pages/${name}`),
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup: ({ el, App, props, plugin }) => {

        const app = createApp({
            data: () => {
                // console.log('app data');

                return {};
            },

            methods: {},

            created: () => {
                // console.log('app created')
            },

            render: () => {
                // console.log('app render');

                return h(App, props);
            },

            mounted: () => {
                // console.log('app mounted');
            },

            updated: () => {
                // console.log('app updated');
            },
        });

        if (import.meta.env.VITE_APP_ENV === 'local') {
            // не давать браузеру "заснуть", иначе после небольшого перерыва дольше перезагружается страница
            const healthcheckCallback = () => {
                fetch(`${import.meta.env.VITE_APP_URL}/api/health-check`)
                    .catch((result) => {
                        clearInterval(healthcheckIntervalId);
                    });
            };
            const healthcheckIntervalId = setInterval(healthcheckCallback, 60 * 1000);
        }

        if (import.meta.env.VITE_APP_ENV === 'production') {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
                integrations: [
                    // new Sentry.BrowserTracing({
                    //     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                    //     tracePropagationTargets: [import.meta.env.VITE_APP_URL],
                    //     // routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                    // }),
                    // new Sentry.Replay(),
                ],
                // // Performance Monitoring
                // tracesSampleRate: import.meta.env.SENTRY_VUE_TRACES_SAMPLE_RATE, // Capture 100% of the transactions, reduce in production!
                // // Session Replay
                // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });

            fetch(`${import.meta.env.VITE_APP_URL}/build/manifest.json?v=${Math.random().toString(36)}`)
                .then((response) => response.json())
                .then((manifest) => {
                    for (const [key, value] of Object.entries(manifest)) {
                        if (value.file.split('.').pop() === 'js') {
                            const link = document.createElement('link');
                            link.rel = 'modulepreload';
                            link.as = 'script';
                            link.crossOrigin = '';
                            link.href = `${import.meta.env.VITE_APP_URL}/build/${value.file}`;
                            document.head.append(link);
                        }
                        // if (value.file.split('.').pop() === 'css') {
                        //     const link = document.createElement('link');
                        //     link.rel = 'stylesheet';
                        //     link.href = `${window.location.origin}/build/${value.file}`;
                        //     document.head.append(link);
                        // }
                    }
                })
                .catch((result) => {
                    console.log(result);
                })
        }

        app.use(plugin);

        app.use(appPlugin);
        app.use(broadcastPlugin);
        app.use(categoryPlugin);
        app.use(companiesParametersPlugin);
        app.use(companyInvoicePlugin);
        app.use(companyPlanPlugin);
        app.use(companyPlugin);
        app.use(companyRegionPlugin);
        app.use(countryPlugin);
        app.use(fileRequestParametersPlugin);
        app.use(fileRequestStatusesPlugin);
        app.use(importCompanyDistributorsPlugin);
        app.use(importPlugin);
        app.use(invoicesParametersPlugin);
        app.use(materialPlugin);
        app.use(brandsPlugin);
        app.use(notificationPlugin);
        app.use(regionPlugin);
        app.use(reportsParametersPlugin);
        app.use(rolePlugin);
        app.use(subscriptionsParametersPlugin);
        app.use(userProfilePlugin);
        app.use(usersParametersPlugin);
        app.use(userStatusPlugin);

        app.mount(el);
    },
});
